// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GoBackButton_wrapper_TZ608","icon":"GoBackButton_icon_1k9kW","text":"GoBackButton_text_12RBB"};